import React, { useState, useEffect } from 'react';
import '../../assets/css/Chat.css';
import SearchIcon from '../../components/icons/SearchIcon';
import TrashIcon from '../../components/icons/TrashIcon';
import PaginationArrowLeftIcon from '../../components/icons/PaginationArrowLeftIcon';
import PaginationArrowRightIcon from '../../components/icons/PaginationArrowRightIcon';

const ChatAdminScreen = () => {
    // This would come from an API in a real app
    const conversations = [
        { id: 'ana_perez', name: 'Ana Pérez (Soporte)', time: 'Hace 3 min', preview: 'Sí, ya revisé el contrato...' },
        { id: 'carlos_lopez', name: 'Carlos López (Ventas)', time: 'Ayer', preview: 'Tenemos una nueva consulta de cliente.' },
        { id: 'equipo_admin', name: 'Equipo Administrativo', time: 'Lunes', preview: 'Recordatorio: Reunión semanal...' },
    ];

    const [activeConversationId, setActiveConversationId] = useState('ana_perez');

    const handleConfirmDelete = (e) => {
        e.stopPropagation(); // Prevent parent onClick from firing
        if (window.confirm("¿Estás seguro de que quieres borrar esta conversación?")) {
            alert("Conversación borrada (simulación).");
            // Here you would add logic to delete the conversation
        }
    };

    // Effect to handle modal logic if needed, e.g., for Bootstrap JS interop
    useEffect(() => {
        // If you need to manually manage the modal with Bootstrap's JS API
    }, []);

    return (
        <>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3">
                <h1 className="h2 mb-md-0">Sistema de Mensajería Interna</h1>
                <div className="btn-toolbar mb-2 mb-md-0">
                    <button type="button" className="btn btn-success d-flex align-items-center" data-bs-toggle="modal" data-bs-target="#nuevoMensajeModal">
                        Crear Nuevo Mensaje
                    </button>
                </div>
            </div>

            <div className="row text-start mb-4">
                <div className="col-12">
                    <div className="card border-0">
                        <div className="card-body p-0">
                            <div className="chat-container">
                                <div className="chat-sidebar">
                                    <h5 className="mb-3">Conversaciones</h5>
                                    <div className="input-group mb-3">
                                        <input type="text" className="form-control" placeholder="Buscar en conversaciones" aria-label="Buscar conversaciones" />
                                        <button className="btn btn-outline-secondary" type="button"><SearchIcon /></button>
                                    </div>
                                    <div className="list-group mb-3">
                                        {conversations.map((convo, index) => (
                                            <div
                                                key={index}
                                                role="button"
                                                tabIndex="0"
                                                className={`list-group-item list-group-item-action text-start ${activeConversationId === convo.id ? 'active' : ''}`}
                                                onClick={() => setActiveConversationId(convo.id)}
                                                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') setActiveConversationId(convo.id); }}
                                            >
                                                <div className="d-flex w-100 justify-content-between">
                                                    <h6 className="mb-1">{convo.name}</h6>
                                                    <small className={activeConversationId !== convo.id ? 'text-muted' : ''}>{convo.time}</small>
                                                </div>
                                                <p className="mb-1 opacity-75">{convo.preview}</p>
                                                <button type="button" className={`btn ${activeConversationId === convo.id ? 'btn-light' : 'btn-outline-secondary'} btn-icon-xs mt-1 float-end`} onClick={handleConfirmDelete} aria-label={`Borrar conversación con ${convo.name}`}>
                                                    <TrashIcon />
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                    <nav aria-label="Paginación de conversaciones">
                                        <ul className="pagination pagination-sm justify-content-center">
                                            <li className="page-item disabled"><a className="page-link" href="#" aria-label="Anterior"><PaginationArrowLeftIcon /></a></li>
                                            <li className="page-item active"><a className="page-link" href="#">1</a></li>
                                            <li className="page-item"><a className="page-link" href="#">2</a></li>
                                            <li className="page-item"><a className="page-link" href="#">3</a></li>
                                            <li className="page-item"><a className="page-link" href="#" aria-label="Siguiente"><PaginationArrowRightIcon /></a></li>
                                        </ul>
                                    </nav>
                                </div>
                                <div className="chat-main">
                                    <div className="chat-messages">
                                        <div className="message received">
                                            <strong>Ana Pérez:</strong> Hola Juan, ¿cómo estás?
                                            <div className="message-meta">10:30 AM</div>
                                        </div>
                                        <div className="message sent">
                                            ¡Hola Ana! Todo bien por acá, ¿y tú? Necesito consultarte sobre el contrato CONTR-PREM-0724.
                                            <div className="message-meta">10:31 AM</div>
                                        </div>
                                        <div className="message received">
                                            <strong>Ana Pérez:</strong> Bien también, gracias. Sí, ya revisé el contrato, ¿qué necesitas saber?
                                            <div className="message-meta">10:33 AM</div>
                                        </div>
                                    </div>
                                    <div className="chat-input">
                                        <input type="text" className="form-control" placeholder="Escribe un mensaje..." />
                                        <button className="btn btn-success">Enviar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal Nuevo Mensaje */}
            <div className="modal fade" id="nuevoMensajeModal" tabIndex="-1" aria-labelledby="nuevoMensajeModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="nuevoMensajeModalLabel">Nuevo Mensaje</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <form id="formNuevoMensaje">
                                <div className="mb-3">
                                    <label htmlFor="destinatarioUsuario" className="form-label">Seleccionar Usuario</label>
                                    <select className="form-select" id="destinatarioUsuario" required defaultValue="">
                                        <option disabled value="">Elija un destinatario...</option>
                                        <option value="ana_perez">Ana Pérez (Soporte)</option>
                                        <option value="carlos_lopez">Carlos López (Ventas)</option>
                                        <option value="equipo_admin">Equipo Administrativo</option>
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="mensajeTexto" className="form-label">Mensaje</label>
                                    <textarea className="form-control" id="mensajeTexto" rows="4" placeholder="Escribe tu mensaje aquí..." required></textarea>
                                </div>
                                <button type="submit" className="btn btn-primary">Enviar Mensaje</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ChatAdminScreen;